module.exports = __webpack_public_path__ + "static/media/black-manat.fda24115.svg";